<template>
  <div class="poster-wrap">
    <el-dialog
      title="修改海报"
      width="1200px"
      :visible="updatePosterDialog"
      @close="closeDialog"
    >
      <el-form ref="form" label-width="100px">
        <el-form-item label="渠道：">
          <el-select v-model="com.channelName">
            <el-option
              v-for="item in comlist"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道账号：">
          <el-input v-model="com.channelAccount"></el-input>
        </el-form-item>
        <el-form-item label="图标：">
          <upload v-model="com.iconUrl" :data="{ platform: 1 }"></upload>
        </el-form-item>
        <el-form-item label="二维码：">
          <upload v-model="com.orCodeUrl" :data="{ platform: 1 }"></upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Upload from 'components/upload';
import { mapActions, mapState, mapMutations } from 'vuex';

export default {
  data() {
    return {
      com: {},
      comlist: [
        { value: '1', label: '微信' },
        { value: '2', label: '微博' },
        { value: '3', label: 'QQ' },
        { value: '4', label: '电报' }
      ]
    };
  },
  props: ['onePoster'],
  computed: {
    ...mapState('community', ['updatePosterDialog'])
  },
  watch: {
    onePoster(val, oldVal) {
      if (val !== oldVal) {
        this.com = { ...val };
      }
    }
  },
  methods: {
    ...mapActions('community', ['remove', 'list']),
    ...mapMutations('community', ['setupdatePosterDialog']),
    imgBack(data) {
      this.position.basicUrl = data;
    },
    closeDialog() {
      this.setupdatePosterDialog(false);
    },
    handleSave() {
      this.remove({ ...this.com })
        .then(res => {
          this.$message.success('操作成功！');
          this.$emit('refresh');
        })
        .finally(() => {
          this.setupdatePosterDialog(false);
        });
    }
  },
  components: {
    Upload
  },
  mounted() {}
};
</script>
<style lang="less">
.uplo {
  margin-top: 20px;
}
.creat-poster {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  .posback {
    position: relative;
    .qrimg {
      position: absolute;
      background: black;
    }
  }
}
.qr-setting {
  border: 1px solid #ddd;
  padding: 50px;
  margin-left: 30px;
  p {
    text-align: center;
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
    .el-button {
      width: 100%;
    }
  }
}
</style>
